import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../axios";

export const fetchFavorites = createAsyncThunk(
  "favorites/fetchFavorites",
  async (type = "TOPIC", { rejectWithValue }) => {
    try {
      const response = await axios.get("/users/favorites", {
        params: { type },
      });
      return { type, data: response.data.data || [] };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to fetch favorites",
      });
    }
  }
);

export const addFavorite = createAsyncThunk(
  "favorites/addFavorite",
  async (itemId, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/users/favorites/${itemId}`);
      const favoriteDoc = response.data.data;
      return {
        itemId,
        favoriteDocId: favoriteDoc._id || favoriteDoc.id,
        type: favoriteDoc.type,
      };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to add favorite",
      });
    }
  }
);

export const removeFavorite = createAsyncThunk(
  "favorites/removeFavorite",
  async ({ favoriteDocId, itemId, type }, { rejectWithValue }) => {
    try {
      await axios.delete(`/users/favorites/${favoriteDocId}`);
      return { favoriteDocId, itemId, type };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data);
      }
      return rejectWithValue({
        success: false,
        message: "Failed to remove favorite",
      });
    }
  }
);
